/******************************************************
 *            Data management exported files
 ********************************************************/

"use strict";

angular.module("exploitation")

	.controller("ExportedFilesCtrl",
		["$scope", "toastr", "Utils", "$uibModal", "ExportedFilesService", "$controller", "AdminClientsService",
		function ($scope, toastr, Utils, $uibModal, ExportedFilesService, $controller, AdminClientsService) {

		$scope.data = {
			files: {}
		};

		/*
		 * Récupère la liste des fichiers exportés
		 */
		AdminClientsService.getReferentialId().then(
			function (refId) {
				ExportedFilesService.getExportedFiles(refId)
					.then((response) => {
						$scope.data.files = response.data.files.sort(sortFilesByDate);
					})
					.catch(() => {
						toastr.error("Problème lors de la récupération des imports");
					});
			});

		/*
 		* Récupère le nom du fichier uniquement
 		*/
		$scope.getFileName = function (file) {
			return file.name.substring(file.name.lastIndexOf("/") + 1);
		};

		/*
		 * Génère l'URL du fichier
		 */
		$scope.downloadFile = function (file) {
			if(file.url) {
				window.open(file.url);
			}
			else {
				toastr.info("Fichier non disponible au téléchargement.");
			}
		};



		function sortFilesByDate(a, b) {
			return new Date(b.created).getTime() - new Date(a.created).getTime();
		}

	}]);
